import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionTypes from '../../store/actions/feedingGuidelinesGenerateAction';
import {getAgeString} from '../../helpers/DateHelper';
import * as moment from 'moment';
import {setCurrentMode, getCurrentMode} from './../../helpers/FeedingGuidelinesHelper';

import Maintenance from './modes/Maintenance';
import Growth from './modes/Growth';
import LactationPregnancy from './modes/LactationPregnancy';
import WeightLoss from './modes/WeightLoss';
import Hospitalization from './modes/Hospitalization';

class FeedingGuidelines extends Component {

  render(){
    const {hideFeedingGuidelines} = this.props;
    const {output} = this.props;


    setCurrentMode(output.casuistic);
    let mode = getCurrentMode();

    if (!mode) {
      return null;
    }

    return  (
      <div id="feeding-guidelines">
        <div className="nppe2-fc-feeding-guidelines" >
          {mode === "maintenance" && <Maintenance output={output} />}
          {mode === "growth" && <Growth output={output} />}
          {mode === "lactation" && <LactationPregnancy output={output} />}
          {mode === "pregnancy" && <LactationPregnancy output={output} />}
          {mode === "weight_adjustment" && <WeightLoss output={output} />}
          {mode === "hospitalisation" && <Hospitalization output={output} />}
        </div>
      </div>
    )
  }
}

const getReproductiveStatusString = (state) => {

  let data = [];
  if (state.signalmentReducer.selectedNursing) data.push(state.signalmentReducer.data.data.nursing);
  if (state.signalmentReducer.selectedPregnant) data.push(state.signalmentReducer.data.data.pregnant);
  if (state.signalmentReducer.selectedSterilised) data.push(state.signalmentReducer.data.data.sterilised);
  if (data.length === 0) data.push(state.signalmentReducer.data.data.default);
  return data.join(", ");
}

const mapStateToProps = state => {
  const reproductiveStatusString = getReproductiveStatusString(state);

  // Get the displayed age string
  const dictionary = {
    day: state.birthDateReducer.data.output.day,
    days: state.birthDateReducer.data.output.days,
    monthDay: state.birthDateReducer.data.output.monthDay,
    monthDays: state.birthDateReducer.data.output.monthDays,
    monthsDay: state.birthDateReducer.data.output.monthsDay,
    monthsDays: state.birthDateReducer.data.output.monthsDays,
    month: state.birthDateReducer.data.output.month,
    months: state.birthDateReducer.data.output.months,
    yearMonth: state.birthDateReducer.data.output.yearMonth,
    yearMonths: state.birthDateReducer.data.output.yearMonths,
    yearsMonth: state.birthDateReducer.data.output.yearsMonth,
    yearsMonths: state.birthDateReducer.data.output.yearsMonths,
    year: state.birthDateReducer.data.output.year,
    years: state.birthDateReducer.data.output.years,
  }

  const birthDate = moment(state.birthDateReducer.selected);
  const todayDate = moment();
  const diffDuration = moment.duration(todayDate.diff(birthDate));
  const difference = {
    years: diffDuration.years(),
    months: diffDuration.months(),
    days: diffDuration.days(),
  }

  const ageString = getAgeString(difference, dictionary);

  // #TODO: implement a better way of doing this
  const activitySelectedIntensity = state.physicalActivityReducer.data.dataLabels[state.physicalActivityReducer.selectedType][Object.keys(state.physicalActivityReducer.data.dataLabels[state.physicalActivityReducer.selectedType])[state.physicalActivityReducer.selectedIntensity]];

  const activitySelectedDuration = state.physicalActivityReducer.data.data[state.animalTypeReducer.animalType][state.physicalActivityReducer.selectedDuration]['label'];

  return {
    output: {
      pet: {
        animalType: state.animalTypeReducer.animalType,
        name: state.petInfoReducer.petName,
        clinicRecordNumber: state.petInfoReducer.clinicRecordNumber,
        breedName: state.breedReducer.selectedData.label,
        age: ageString,
        gender: state.genderReducer.selected,
        reproductiveStatus: reproductiveStatusString,
        size: state.breedReducer.selectedData.size,
        weight: {
          current: state.bodyConditionReducer.selectedBodyWeight,
          goal: state.bodyConditionReducer.selectedGoalWeight,
          ideal: state.idealBodyWeightReducer.idealBodyWeight,
          bcs: state.conditionScoreReducer.selected,
        },
      },
      mealsPerDay: state.petInfoReducer.mealsPerDay,
      activity: {
        duration: activitySelectedDuration,
        intensity: activitySelectedIntensity,
        temperature: state.physicalActivityReducer.selectedTemperature,
      },
      products: state.productsReducer.selected,
      diagnoses: state.diagnosesReducer.selectedData,
      meta : {
        pregnancyFactor: state.weeksLitterReducer.pregnancyFactor,
        nursingFactor: state.weeksLitterReducer.nursingFactor,
        sterilisedFactor: state.weeksLitterReducer.sterilisedFactor,
        sizeFactor: state.breedReducer.sizeFactor,
        activityFactor: state.physicalActivityReducer.activityFactor,
        growthFactor: state.bodyConditionReducer.growthFactor,
        temperatureFactor: state.physicalActivityReducer.temperatureFactor,
        illnessFactor: state.diagnosesReducer.illnessFactor,
        idealBodyWeight: state.idealBodyWeightReducer.idealBodyWeight,
        lifeStage: state.birthDateReducer.lifeStage,
        casuistic: state.criticalCareReducer.casuistic,
        bodyWeight: state.idealBodyWeightReducer.bodyWeight,
        rer: state.dailyIntakeReducer.rer,
        der: state.dailyIntakeReducer.der,
      },
      recommended : getRecommended(state),
      casuistic: state.calculateDerReducer.data.casuistic,
      isAnorexia: state.criticalCareReducer.isAnorexia,
    },
  }
};

const getRecommended = (state) => {
  let recommended = {
    "dryFood" : [],
    "wetFood" : [],
    "related" : [],
    "snacks" : [],
  };

  const types = [
    "dry",
    "wet",
    "supplement",
    "snack",
  ];

  Object.keys(state.productsReducer.selectedData).forEach((key, value) => {
    const product = state.productsReducer.selectedData[key];

    // Products should only belong to a single type
    let pushKey = null;
    product.types.forEach(type => {
      pushKey = type
    });

    if (pushKey !== null){

      let data = {
        title: product.label,
      };

      switch(pushKey){
        case "dry":
          recommended['dryFood'].push(data);
          break;

        case "wet":
          recommended['wetFood'].push(data);
          break;

        case "supplement":
          recommended['related'].push(data);
          break;

        case "snack":
          recommended['snacks'].push(data);
          break;
      }

    }
  });

  return recommended;
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      dispatch,
    ),
    hideFeedingGuidelines: () => dispatch({
      type: actionTypes.HIDE_FEEDING_GUIDELINES,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelines);
